import React, { useState, useEffect } from 'react';
import { Col, Row, message } from 'antd';
import { withRouter } from 'react-router';
import GeneralOfferForm from 'components/GeneralOfferForm/GeneralOfferForm';
import PublishForm from 'components/PublishForm/PublishForm';
import parseOfferDataToEdit from 'utils/data/parseOfferDataToEdit';
import parseDepartureData from 'utils/data/parseDepartureData';
import BasicFlightForm from 'components/BasicFlightForm/BasicFlightForm';
import postApi from 'utils/api/post/PostApi';
import FlightPlusHotelForm from 'components/FlightHotelForm/FlightPlusHotelForm';
import PropTypes from 'prop-types';
import PushNotificationForm from 'components/PushNotificationForm/PushNotificationForm';
import './FlightPlusHotelFormContainer.less';
import '../styles/FormCommon.less';

const FlightPlusHotelFormContainer = (props) => {
  const { location, token } = props;
  const locationPath = location.pathname.split('/');

  const [flights, setFlights] = useState({});
  const [generalData, setGeneralData] = useState({});
  const [hotelData, setHotelData] = useState({});
  const [departureData, setDepartureData] = useState([]);
  const [offerData, setOfferData] = useState({});
  const [postToEdit, setPostToEdit] = useState({
    amenities: {},
    data: {},
    flights: {},
    iatas: [],
    providers: [],
    render: !!locationPath[2],
  });
  const [pushNotificationData, setPushNotificationData] = useState({ error: false });

  /**
   * This method receives the validated and formated JSON from
   * the FlightPlusHotelForm
   * @param {JSON} values
   */
  const handleFlightPlusHotelData = (hotelFormData) => {
    setHotelData(hotelFormData);
  };

  /**
   * This method receives the validated and formated JSON from
   * the GeneralOfferForm
   * @param {JSON} values
   */
  const handleGeneralOfferData = (generalFormData) => {
    setGeneralData(generalFormData);
  };

  /**
   * This method receives the validated and formated JSON from
   * the BasicFlightForm
   * @param {JSON} values
   */
  const handleFlightsData = (flightsData) => {
    setFlights(flightsData);
  };

  /**
   * Method to parse data from server in order to make it match with
   * structure needed in front-end
   *
   * @param {Object} serverData
   * @returns {Object} iataList, flightsInfo
   */
  const parseReceivedData = (serverData) => parseOfferDataToEdit(serverData);

  /**
   * Method to get post byId
   * @param id
   * @returns {Promise<>}
   */
  const getPostById = async (id) => {
    try {
      const response = await postApi.getPost(id, token);
      if (response.status === 200) {
        const {
          amenities, iataList, flightsInfo, providers,
        } = parseReceivedData(response.data);
        setPostToEdit({
          amenities,
          data: response.data,
          iatas: iataList,
          flights: flightsInfo,
          render: true,
          providers,
        });
      }
    } catch (err) {
      message.error(err.toString());
    }
  };

  /**
   *  Method that parses the form data to an structure that Flight service is
   *  expecting. It does work with the flights state/hook
   */
  const handleParseDepartureData = () => {
    const tempDepartureData = parseDepartureData(flights.departures_iatas, flights.flights);
    if (tempDepartureData.length) setDepartureData(tempDepartureData);
  };

  /**
   * Method just to validate if the state are rendering correctly
   */
  useEffect(() => {
    if (flights.flights && Object.keys(flights.flights).length > 0) {
      handleParseDepartureData();
    }
  }, [hotelData, generalData, flights]);

  /**
   * UseEffect to get the data.
   */
  useEffect(() => {
    if (locationPath[2]) {
      getPostById(locationPath[2]);
    }
  }, []);

  /**
   * TODO: Need to valid with GI
   * UseEfect to reset the hook if the user after click to edit click again on
   * Oferta General sider button
   */
  useEffect(() => {
    if (!locationPath[2] && postToEdit.render) {
      setPostToEdit({
        render: false,
        data: {},
        flights: {},
        iatas: [],
        amenities: {},
      });
      setOfferData({});
    }
  }, [location]);

  useEffect(() => {
    if (Object.keys(generalData).length > 0 && Object.keys(hotelData).length > 0) {
      const data = { ...generalData };
      data.amenities = { ...hotelData };
      data.departure_data = departureData;
      data.lowest_price = flights.lowest_price;
      data.lowest_price_url = flights.provider_permalink;
      data.providers = flights.providers;
      // If push notification has info
      if (pushNotificationData.content) {
        data.push_notification = {
          ...pushNotificationData,
          destinations_iatas: flights.destinations_iatas,
          departures_iatas: flights.departures_iatas,
          months: flights.months,
        };
      } else if (data.push_notification) {
        // Remove the push_notification data.
        delete data.push_notification;
      }
      setOfferData(data);
    }
  }, [departureData, pushNotificationData]);

  const handlePushNotificationData = (values) => {
    setPushNotificationData(values);
  };

  return (
    <div className="flight-plus-hotel-form-content">
      <div className="flight-plus-hotel-form">
        <Row gutter={20}>
          <Col span={16}>
            <div className="flight-plus-hotel-form-header">
              <h2 className="form-title">Vuelo más hotel</h2>
            </div>
            <GeneralOfferForm data={postToEdit.data} handleRequest={handleGeneralOfferData} nested renderToEdit={postToEdit.render} token={token} />
          </Col>
          <Col span={6}>
            <div className="flight-plus-hotel-sider">
              <PublishForm offerType="Vuelo más Hotel" data={offerData} postToEdit={postToEdit} />
            </div>
          </Col>
        </Row>
        <FlightPlusHotelForm amenities={postToEdit.amenities} handleRequest={handleFlightPlusHotelData} />
        <BasicFlightForm
          flightHotel
          handleRequest={handleFlightsData}
          isRound
          savedFlights={postToEdit.flights}
          savedIatas={postToEdit.iatas}
          savedProviders={postToEdit.providers}
          token={token}
        />
        <Row gutter={20}>
          <PushNotificationForm handleRequest={handlePushNotificationData} pushNotificationData={postToEdit.data.push_notification} />
        </Row>
      </div>
    </div>
  );
};

FlightPlusHotelFormContainer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
};

export default withRouter(FlightPlusHotelFormContainer);
